<template>
  <div
    class="custom-global-skeleton assessment-category-detail-skeleton tw-bg-[#ffffff] tw-min-w-[241px] tw-max-w-[241px] tw-p-[25px] tw-w-full tw-flex tw-flex-col tw-justify-between tw-items-start tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-rounded-[6px] tw-border-solid tw-border-[#EFF0F1] tw-gap-[20px]"
  >
    <div
      class="tw-font-Poppins tw-text-[12px] tw-font-[600] tw-text-[#211F58] tw-uppercase tw-leading-[100%] tw-tracking-[1.2px] tw-w-[100px] tw-h-[12px]"
    ></div>
  </div>
</template>

<style lang="scss" scoped>
.assessment-category-detail-skeleton {
  min-height: 113px;
  max-height: 113px;
}
</style>
